import { FormikConfig, FormikErrors, FormikHelpers, FormikValues, useFormik, yupToFormErrors } from "formik";
import { useState } from "react";
import { InferType, ValidationError } from "yup";

export interface IFormikWrapperConfig<T> extends FormikConfig<T> {
    onError?(errors: FormikErrors<T>): void;
}

export const useFormikWrapper = <T extends FormikValues>({ validationSchema, onError, onSubmit, ...rest }: IFormikWrapperConfig<T>) => {
    const [submittedOnce, setSubmittedOnce] = useState(false);

    type FormValues = InferType<typeof validationSchema>;

    const handleSubmit = async (values: T, helpers: FormikHelpers<T>) => {
        setSubmittedOnce(true);

        try {
            await validationSchema.validate(values, { abortEarly: false });
            onSubmit?.(values, helpers);
        } catch (err) {
            if (err instanceof ValidationError) {
                const formikErrors = yupToFormErrors<FormValues>(err);
                helpers.setErrors(formikErrors);
                onError?.(formikErrors);
            }
        }
    }

    const formik = useFormik({
        ...rest,
        validationSchema: submittedOnce ? validationSchema : undefined,
        validateOnChange: submittedOnce,
        onSubmit: handleSubmit,
    });

    return formik;
}